export default __webpack_public_path__ + "static/media/11.b5db9d20.jpeg";